import { RUN } from '../config/gameConfig';

export class LaneSystem {
  readonly laneCount: number;
  private currentLane: number;
  private targetLane: number;
  private progress = 1;
  private readonly durationMs: number;

  constructor(laneCount = RUN.lanes, startLane = 1) {
    this.laneCount = laneCount;
    this.currentLane = startLane;
    this.targetLane = startLane;
    this.durationMs = RUN.laneChangeMs;
  }

  reset(startLane = 1): void {
    this.currentLane = startLane;
    this.targetLane = startLane;
    this.progress = 1;
  }

  get lane(): number {
    return this.targetLane;
  }

  get visualLane(): number {
    if (this.progress >= 1) return this.targetLane;
    const t = this.ease(this.progress);
    return this.currentLane + (this.targetLane - this.currentLane) * t;
  }

  get isMoving(): boolean {
    return this.progress < 1;
  }

  tryMove(dir: -1 | 1): boolean {
    if (this.isMoving) return false;
    const next = this.targetLane + dir;
    if (next < 0 || next >= this.laneCount) return false;
    this.currentLane = this.targetLane;
    this.targetLane = next;
    this.progress = 0;
    return true;
  }

  update(deltaMs: number): void {
    if (this.progress >= 1) return;
    this.progress = Math.min(1, this.progress + deltaMs / this.durationMs);
    if (this.progress >= 1) {
      this.currentLane = this.targetLane;
    }
  }

  laneX(width: number, roadInset: number, lane: number = this.visualLane): number {
    const usable = width - roadInset * 2;
    const laneW = usable / this.laneCount;
    return roadInset + laneW * (lane + 0.5);
  }

  private ease(t: number): number {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }
}
